import type { ConfirmationModalProps } from '@library/components/modals/ConfirmationModal';
import { useState } from 'react';

export function useConfirmationModal() {
  const [confirmationModalProps, setConfirmationModalProps] = useState<
    Omit<ConfirmationModalProps, 'onCancelModal'> | false
  >(false);

  const resetConfirmationModal = () => {
    setConfirmationModalProps(false);
  };

  const handleSubmit = async () => {
    if (confirmationModalProps) {
      const { handleConfirm } = confirmationModalProps;

      await handleConfirm();
    }
    resetConfirmationModal();
  };

  const updateConfirmationModalProp = (
    updateFn: (
      prevProps: Omit<ConfirmationModalProps, 'onCancelModal'>
    ) => Omit<ConfirmationModalProps, 'onCancelModal'>
  ) => {
    setConfirmationModalProps((prevProps) => {
      if (prevProps === false) {
        return prevProps;
      }
      return updateFn(prevProps);
    });
  };

  return {
    confirmationModalProps,
    handleSubmit,
    resetConfirmationModal,
    setConfirmationModalProps,
    updateConfirmationModalProp
  };
}
